/* eslint-disable */
import React, { useEffect, useContext } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { WebSocketContext } from "../../../App";
import wsSend_request from "../../../Api/ws/ws_request";
import { useSelector, useDispatch } from "react-redux";
import CommonDateTime from "../../Common/CommonDateTime";
import { updateOrderManagementFilter } from "../../../redux/actions/adminActions";
import CommonTable from "../../Common/CommonTable";
import MainOrderDataTableFilter from "../../Common/MainOrderDataTableFilter";

const FranchisePendingDelivery = (props) => {
  const Dispatch = useDispatch();
  const { websocket } = useContext(WebSocketContext);
  const { device_id, DeliveredList, OrderManagmentFilter, sortingfor } =
    useSelector((state) => state.adminReducers);

  // get all product list
  useEffect(() => {
    let param = {
      transmit: "broadcast",
      url: "product_list",
      request: {
        status: true,
        limit: 5000,
        page_no: 1,
        search: "",
      },
      DeviceId: device_id,
    };
    wsSend_request(websocket, param);
  }, [websocket]);

  // get all warehouse list
  useEffect(() => {
    let param = {
      transmit: "broadcast",
      url: "warehouse_list",
      request: {
        status: "",
        limit: 5000,
        page_no: 1,
        search: "",
      },
      DeviceId: device_id,
    };
    wsSend_request(websocket, param);
  }, [websocket]);

  // get all region list
  useEffect(() => {
    let param = {
      transmit: "broadcast",
      url: "region_list",
      request: {
        status: "",
        limit: 5000,
        page_no: 1,
        search: "",
      },
      DeviceId: device_id,
    };
    wsSend_request(websocket, param);
  }, [websocket]);

  // page change
  const currentFunction = (page) => {
    Dispatch(
      updateOrderManagementFilter({
        OrderDelivered: {
          CurrentPage: page,
        },
      })
    );
  };

  // api calling
  const APICall = () => {
    const {
      UserLimit,
      UserSearch,
      SelectDateType,
      SelectRegion,
      WarehouseName,
      ProductName,
      OrderSource,
      FromDate,
      ToDate,
      CurrentPage,
      is_bundle_orders,
      is_odi_courier_pin,
    } = OrderManagmentFilter?.OrderDelivered;

    let param = {
      transmit: "broadcast",
      url: "order_list",
      request: {
        status: "DELIVERED",
        limit: UserLimit,
        page_no: CurrentPage,
        search: UserSearch.trim(),
        from_date: null,
        to_date: null,
        from_inv: null,
        to_inv: null,
        from_updated_date: null,
        to_updated_date: null,
        order_type: OrderSource,
        region_id: SelectRegion,
        order_by: sortingfor,
        is_bundle_orders: is_bundle_orders,
        pin_code_flag: is_odi_courier_pin?.flag,
        include_shipments: true,
      },
      DeviceId: device_id,
    };

    if (SelectDateType === "created_at") {
      if (FromDate !== "" && ToDate !== "") {
        param.request.from_date = CommonDateTime(
          FromDate,
          "YYYY-MM-DD",
          "hide"
        );
        param.request.to_date = CommonDateTime(ToDate, "YYYY-MM-DD", "hide");
      }
    } else if (SelectDateType === "invoice_at") {
      if (FromDate !== "" && ToDate !== "") {
        param.request.from_inv = CommonDateTime(FromDate, "YYYY-MM-DD", "hide");
        param.request.to_inv = CommonDateTime(ToDate, "YYYY-MM-DD", "hide");
      }
    } else {
      if (FromDate !== "" && ToDate !== "") {
        param.request.from_updated_date = CommonDateTime(
          FromDate,
          "YYYY-MM-DD",
          "hide"
        );
        param.request.to_updated_date = CommonDateTime(
          ToDate,
          "YYYY-MM-DD",
          "hide"
        );
      }
    }

    if (WarehouseName) {
      param.request.warehouse_id = WarehouseName?.map(
        (elm) => elm?.value
      )?.toString();
    }

    if (ProductName) {
      param.request.product_id = ProductName?.map(
        (elm) => elm?.value
      )?.toString();
    }

    wsSend_request(websocket, param);
  };

  useEffect(() => {
    APICall();
  }, [websocket, OrderManagmentFilter?.OrderDelivered]);

  useEffect(() => {
    if (sortingfor !== "" && sortingfor !== "-") {
      APICall();
    }
  }, [sortingfor]);

  // TABLE COLUMNS ARRAY
  const TableColumns = [
    {
      key: "shipping_manifest_link",
      label: "Shipping Manifest Link",
      type: "shipping_manifest_link_download",
      sort: "",
      isCollapsable: false,
    },
    {
      key: "order_code",
      label: "Order Id.",
      type: "label",
      sort: "order_code",
      isCollapsable: false,
    },
    {
      key: "erp_id",
      label: "ERP Order Code",
      type: "label",
      sort: "",
      isCollapsable: false,
    },
    {
      key: "customer_identity",
      label: "Customer Code",
      type: "label",
      sort: "customer_identity",
      isCollapsable: false,
    },
    {
      key: "created_at",
      label: "Order Date",
      type: "date",
      sort: "created_at",
      isCollapsable: false,
    },
    {
      key: "updated_at",
      label: "Updated Date",
      type: "date",
      sort: "updated_at",
      isCollapsable: false,
    },
    {
      key: "order_source",
      label: "Order Source",
      type: "label",
      sort: "",
      isCollapsable: false,
    },
    {
      key: "customer_name",
      label: "SHIP To Name",
      type: "label",
      sort: "customer_name",
      isCollapsable: false,
    },
    {
      key: "billing_id",
      label: "BILL To Name",
      type: "label_get_from_franchise",
      sort: "billing_id",
      isCollapsable: false,
    },
    {
      key: "",
      label: "Old Warehouse",
      type: "label_old_warehouse",
      sort: "",
      isCollapsable: false,
    },
    {
      key: "warehouse_id",
      label: "Ship From Warehouse",
      type: "label_get_ship_warehouse",
      sort: "",
      isCollapsable: false,
    },
    {
      key: "invoice_code",
      label: "Invoice ID",
      type: "invoice_regular_modal_open_navigate",
      sort: "invoice_code",
      isCollapsable: false,
    },
    {
      key: "invoice_at",
      label: "Invoice Date",
      type: "date",
      sort: "invoice_at",
      isCollapsable: false,
    },
    {
      key: "dispatch_date",
      label: "Dispatch Date",
      type: "date",
      sort: "dispatch_date",
      isCollapsable: false,
    },
    {
      key: "courier_name",
      label: "Transporter",
      type: "label",
      sort: "courier_name",
      isCollapsable: false,
    },
    {
      key: "order_priority",
      label: "Order Priority",
      type: "label",
      sort: "order_priority",
      isCollapsable: false,
    },
    {
      key: "delivered_date",
      label: "Delivered Date",
      type: "date",
      sort: "delivered_date",
      isCollapsable: false,
    },
    {
      key: "pod_link",
      label: "Pod Link",
      type: "pod_link_navigate",
      sort: "pod_link",
      isCollapsable: false,
    },
    {
      key: "docket_number",
      label: "Docket Number",
      type: "label_docket_number",
      sort: "docket_number",
      isCollapsable: false,
    },
    {
      key: "is_automated",
      label: "Automated",
      type: "status_yes_no",
      sort: "",
      isCollapsable: false,
    },
    {
      key: "erp_id",
      label: "ERP Api Status",
      type: "label_erp_invoice_delivery_note_api_status",
      sort: "",
      isCollapsable: false,
    },
    {
      key: "erp_invoice_code",
      label: "ERP Invoice Status",
      type: "label_erp_invoice_delivery_note_api_status",
      sort: "",
      isCollapsable: false,
    },
    {
      key: "erp_delivery_code",
      label: "ERP Delivery Note API status",
      type: "label_erp_invoice_delivery_note_api_status",
      sort: "",
      isCollapsable: false,
    },
    {
      key: "so_outstanding_breached",
      label: "SO Outstanding Breached",
      type: "status_yes_no",
      sort: "",
      isCollapsable: false,
    },
    {
      key: "updated_at",
      label: "Pending Since",
      type: "pending_since",
      sort: "updated_at",
      isCollapsable: false,
    },
    {
      key: "warehouse_remark",
      label: "Remarks",
      type: "label",
      sort: "",
      isCollapsable: false,
    },
    {
      key: "shipment_logs",
      label: "Shipment Logs",
      type: "shipment_logs_type",
      sort: "shipment_logs",
      isCollapsable: true,
    },
    {
      key: "qty",
      label: "Quantity",
      type: "label",
      sort: "qty",
      isCollapsable: true,
    },
    {
      key: "total",
      label: "Order Value",
      type: "label_day_ammount",
      sort: "total",
      isCollapsable: true,
    },
    {
      key: "category",
      label: "SKU Type",
      type: "label",
      sort: "",
      isCollapsable: true,
    },
    {
      key: "order_status",
      label: "Status",
      type: "label_order_status",
      sort: "",
      isCollapsable: true,
    },
    {
      key: "priority",
      label: "Criticality",
      type: "label_Criticality",
      sort: "priority",
      isCollapsable: true,
    },
    {
      key: "",
      label: "",
      type: "Attachments_SoApprovals",
      sort: "",
      isCollapsable: true,
    },
    {
      key: "region_id",
      label: "Region",
      type: "label_get_from_list",
      filterFrom: { list: "regionlist", label: "region_name" },
      sort: "",
      isCollapsable: true,
    },
  ];

  return (
    <section className="Main_section">
      <MainOrderDataTableFilter
        filterType={""}
        tabName={"OrderDelivered"}
        searchType={
          "Order Id, ERP Order Code, Name, Invoice ID, Customer Code, Docket Number"
        }
        FromDateStartDateFlag={true}
        searchdisable={true}
        buttonvisible={false}
        AllOrderStatusAllow={false}
        isAllowWarehouse={true}
        isAllowProduct={true}
        isDateType={true}
        isOdiFilterAllow={true}
        isRegionAllow={true}
        isBundleOrdersAllow={true}
        isOrderSourceAllow={true}
      />
      {/* COMMON TABLE */}
      <CommonTable
        isTableAllow={true}
        style={{
          height:
            parseInt(DeliveredList?.pagination?.total_records) ===
            DeliveredList?.list?.length
              ? "calc(100vh - 196px)"
              : parseInt(DeliveredList?.pagination?.total_records) > 10
              ? "calc(100vh - 235px)"
              : "calc(100vh - 196px)",
        }}
        srNumber={{
          clickable: true,
          events: "ORDERS_LOG",
        }}
        isCollapsable={true}
        tabName={""} // TAB URL
        PaginationCurrentPage={
          OrderManagmentFilter["OrderDelivered"]?.CurrentPage
        } // TAB CURRENT PAGE
        PaginationFunction={currentFunction} // PAGINATION CHNAGE FUNCTION
        TableColumns={TableColumns} // TABLE COLLUMNS & ROWS
        OrderList={DeliveredList} // ORDER LIST
        Pagination={DeliveredList?.pagination} // CURRENT TAB PAGINATION
        EditAccess={true} // EDITABLE ACCESS STATE
        APIcalling={APICall}
        isActionColumnAvailable={{
          isShow: true,
          label: "pod_upload",
          naviagte: null,
        }}
        isActionTwoColumnAvailable={{
          isShow: false,
          url: "",
        }}
        isOdiFilterRowColorsAllow={true}
        isPodFilterRowColorsAllow={true}
      />
    </section>
  );
};

export default FranchisePendingDelivery;
